import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { Platform } from "../../src/landingPage/views/Platform/Platform";
import { meta } from "../../src/landingPage/datasets/meta";

const PlatformPage = () => {
  return (
    <>
      <NextHead
        currentPath="/platform"
        title={meta.platform.title}
        description={meta.platform.description}
      />
      <Platform />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default PlatformPage;
